var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "infinite-scroll" },
    [
      _c(
        "div",
        {
          ref: "infiniteScroll",
          staticClass: "infinite-scroll__container",
          style: { "max-height": _vm.maxHeight },
        },
        [
          _vm._t("default"),
          _vm._v(" "),
          _vm.lastItems
            ? _c("div", { staticClass: "last_items" }, [
                _vm._v("\n      Não há mais dados para exibir\n    "),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.loading
        ? _c("AppLoadingIcon", {
            staticClass: "loading",
            attrs: { color: "#BBB" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }